<template>
  <div class="section grid-view">
    <div class="main-content">
      <div class="operations">
        <div class="triggers">
          <div class="button-container">
            <el-button
              no="new"
              :disabled="!isEdit||hasContractManage"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit||hasContractManage"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button
              no="delete"
              :disabled="!isEdit||hasContractManage"
              type="danger"
              @click="remove"
            >{{ $t('common.btn.delete') }}</el-button>
            <!-- 启用/禁用合同限制按钮 -->
            <el-button
              v-if="$checkPermission(['button_enable_contract_limit'])"
              no="toggleContractLimit"
              :disabled="!isEdit"
              :type="contractLimitEnabled ? 'danger' : 'primary'"
              @click="toggleContractLimit"
            >{{ contractLimitEnabled ? $t('Partners.disableContractLimit') : $t('Partners.enableContractLimit') }}</el-button>
            <!-- 编辑放号天数按钮 - 需要权限且已启用合同限制 -->
            <el-button
              v-if="$checkPermission(['button_enable_contract_limit']) && contractLimitEnabled"
              no="editReleaseDays"
              :disabled="!isEdit"
              type="primary"
              @click="showEditReleaseDaysDialog"
            >{{ $t('Partners.editReleaseDays') }}</el-button>
            <!-- 可放号天数显示 - 需要权限且已启用合同限制 -->
            <span v-if="$checkPermission(['button_enable_contract_limit']) && contractLimitEnabled" class="release-days-inline">
              {{ $t('Partners.availableReleaseDays') }}：
              <el-popover
                placement="right"
                width="400"
                trigger="hover"
                popper-class="release-days-popover"
              >
                <div class="popover-content">未传合同：25天−客户创建日至当日间隔，负数计 0<br>已传合同：取最晚合同失效日减当日，负数计 0<br>系统自动计算，支持手动修改</div>
                <span class="release-days-number" slot="reference">{{ availableReleaseDays }}</span>
              </el-popover>
            </span>
            <br>
            <span v-show="hasContractManage" style="color:red">{{ $t('Partners.operateInMasterDataContractManagement') }}</span>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Partners.effectiveDate')">
            <el-date-picker
              v-model="editDialog.form.beginDate"
              no="beginDate"
              type="date"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.expiryDate')">
            <el-date-picker
              v-model="editDialog.form.endDate"
              no="endDate"
              type="date"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FileNo')">
            <el-input v-model="editDialog.form.contractNo" no="contractNo" />
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 文件上传对话框 -->
    <cargo-file-upload-dialog
      :visible.sync="fileUpload.visible"
      :title="fileUpload.title"
      :document-category="fileUpload.documentCategory"
      :business-id="fileUpload.businessId"
      :show-file-category="fileUpload.showFileCategory"
      :lob="fileUpload.lob"
      :parameters="fileUpload.parameters"
      @uploadDone="onUploadDone"
    />
    <!-- 编辑放号天数弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editReleaseDaysDialog.visible"
      :title="$t('Partners.editReleaseDays')"
      width="450px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="$t('Partners.availableReleaseDays')">
            <el-input-number
              v-model="editReleaseDaysDialog.form.availableReleaseDays"
              no="availableReleaseDays"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 100%"
              @change="onReleaseDaysChange"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.releaseDeadlineDate')">
            <el-date-picker
              v-model="editReleaseDaysDialog.form.releaseDeadlineDate"
              no="releaseDeadlineDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              @change="onReleaseDeadlineDateChange"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="saveEditReleaseDays">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="editReleaseDaysDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoFileUploadDialog from '@/components/Cargo/Common/cargoFileUploadDialog'
import {
  getContractList,
  enableContractLimit as apiEnableContractLimit,
  disableContractLimit as apiDisableContractLimit,
  saveReleaseDays,
  saveReleaseDaysAndConvertToTicket,
  getReleaseDaysHistory,
  getContractLimitStatus
} from '@/api/partner/contract'
import { getCreditInfoList } from '@/api/partner/creditInfo'
import { hasMenu, AutoIncrementNum } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import { updateContractFunc } from '@/api/seaExport/businessDocument'

export default {
  name: 'ContractForm',
  components: { cargoFileUploadDialog },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hasContractManage: false,
      filter: {
        companyUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Partners.effectiveDate'),
          field: 'beginDate',
          width: 200
        }, {
          headerName: this.$t('Partners.expiryDate'),
          field: 'endDate',
          width: 200
        }, {
          headerName: this.$t('SeaExport.FileNo'),
          field: 'contractNo',
          width: 200
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        }, {
          headerName: this.$t('Partners.documentSize'),
          field: 'documentSize',
          width: 100
        }, {
          headerName: this.$t('Partners.attachment'),
          width: 100,
          cellRenderer: params => {
            // 通过 context 获取组件实例，判断是否处于编辑状态
            const componentParent = params.context?.componentParent
            const isEditable = componentParent?.isEdit || false
            const disabledStyle = isEditable ? '' : 'color:#ccc;cursor:not-allowed;pointer-events:none;'
            const disabledAttr = isEditable ? '' : 'disabled="disabled"'
            return `<u onclick="document.contractForm.uploadAttachment('${params.data.uuid}')" style="color:#46a6ff;cursor:pointer;${disabledStyle}" ${disabledAttr}>${componentParent?.$t('Partners.uploadFile') || '上传文件'}</u>`
          }
        }
      ],
      rowData: [],
      deletedContractKeys: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: {
          uuid: '',
          beginDate: '',
          endDate: '',
          contractNo: '',
          remarks: '',
          companyUuid: ''
        },
        form: {}
      },
      fileUpload: {
        visible: false,
        title: this.$t('Partners.UpdateMaterial'),
        documentCategory: 1003,
        businessId: '',
        showFileCategory: true,
        lob: 'PT',
        parameters: {
          companyKey: '',
          uuid: '',
          documentType: this.$t('Partners.contract'),
          createdBy: 0
        }
      },
      autoIncrementNum: new AutoIncrementNum(),
      company: new Company().fillDefaultValue(),
      // 合同限制相关
      contractLimitEnabled: false, // 是否启用合同限制
      availableReleaseDays: 0, // 可放号天数
      releaseDeadlineDate: '', // 可放号截止日期
      editReleaseCount: 0, // 编辑放号天数次数
      cumulativeDaysChange: 0, // 累计天数变化值
      updateContractFlag: null, // 合同更新标识：null-未变化，'1'-合同信息变化，'2'-放号天数变化
      originalContracts: [], // 原始合同数据快照，用于对比变化
      changedContracts: new Set(), // 记录发生变化的合同UUID集合
      editReleaseDaysDialog: {
        visible: false,
        form: {
          availableReleaseDays: 0,
          releaseDeadlineDate: ''
        }
      },
      creditInfo: null // 信用账款信息缓存
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    }
  },
  beforeMount() {
    const context = this
    document.contractForm = {
      uploadAttachment(uuid) {
        context.uploadAttachment(uuid)
      }
    }
  },
  methods: {
    onShow(row, isRefresh) {
      this.company = row || null
      this.hasContractManage = hasMenu('ContractManagement')
      if (isRefresh) {
        this.initColumnDefs()
        this.filter.companyUuid = row.uuid
        this.toQuery()
        this.fileUpload.parameters.companyKey = row.uuid
        this.fileUpload.parameters.createdBy = this.$store.getters.userId
        this.deletedContractKeys = []
        // 重置合同限制状态
        this.contractLimitEnabled = false
        this.availableReleaseDays = 0
        this.releaseDeadlineDate = ''
        this.creditInfo = null
        // 重置合同更新标识
        this.updateContractFlag = null
        this.originalContracts = []
        this.changedContracts.clear()
        // 获取合同限制状态
        this.loadContractLimitStatus()
      }
    },
    async initColumnDefs() {
      if (this.hasContractManage && !this.isExistField('contractAgreement')) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.Cargo_ContractAgreement'),
            field: 'contractAgreement',
            hide: true,
            width: 100,
            cellRenderer: (params) => {
              if (params.value) {
                return ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACTAGREEMENT_TYPE, params.value)
              }
              return ''
            }
          }
        )
      }
    },
    isExistField(field) {
      return this.columnDefs.findIndex(p => p.field === field) > -1
    },
    toQuery() {
      if (this.filter.companyUuid) {
        getContractList(this.filter).then(res => {
          res.data.list.forEach(p => {
            if (p.beginDate) {
              p.beginDate = p.beginDate.substr(0, 10)
            }
            if (p.endDate) {
              p.endDate = p.endDate.substr(0, 10)
            }
            p.seq = this.autoIncrementNum.getNextNum()
          })
          this.rowData = res.data.list
          // 保存原始数据快照，用于后续对比
          this.originalContracts = JSON.parse(JSON.stringify(this.rowData))
          // 清空变化记录
          this.changedContracts.clear()
        })
      } else {
        this.rowData = []
        this.originalContracts = []
        this.changedContracts.clear()
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = JSON.parse(JSON.stringify(this.editDialog.initialForm))
        this.editDialog.form.seq = this.autoIncrementNum.getNextNum()
        this.editDialog.form.companyUuid = this.filter.companyUuid
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    getSubmitData() {
      if (this.rowData && this.rowData.length > 0) {
        let branchId = this.$store.getters.currentOfficeId
        if (this.company && this.company.branchId && this.company.branchId > 0) {
          branchId = this.company.branchId
        }
        for (const item of this.rowData) {
          if (!item.uuid) {
            item.branchId = branchId
          }
        }
      }
      const data = {
        contracts: this.rowData,
        deletedContractKeys: this.deletedContractKeys
      }
      // 如果有更新标识，则添加到返回数据中
      if (this.updateContractFlag !== null && this.updateContractFlag !== undefined) {
        data.updateContractFlag = this.updateContractFlag
      }
      return data
    },
    saveSub() {
      if (!this.checkForm()) return
      const oldRow = this.rowData.find(p => p.seq === this.editDialog.form.seq)
      
      if (oldRow) {
        // 编辑现有合同：检查失效日期和附件数量是否变化
        const oldEndDate = oldRow.endDate || ''
        const newEndDate = this.editDialog.form.endDate || ''
        const oldDocumentSize = oldRow.documentSize || 0
        const newDocumentSize = this.editDialog.form.documentSize || 0
        
        // 如果发生变化，记录到变化集合中
        if (oldEndDate !== newEndDate || oldDocumentSize !== newDocumentSize) {
          if (oldRow.uuid) {
            this.changedContracts.add(oldRow.uuid)
          }
        }
        
        Object.assign(oldRow, this.editDialog.form)
        this.gridApi.refreshCells({ force: true })
      } else {
        // 新增合同：直接加入列表，并标记为新增（无uuid）
        this.rowData.push(this.editDialog.form)
        // 新增的合同没有uuid，用seq作为标识
        this.changedContracts.add('new_' + this.editDialog.form.seq)
      }
      
      // 检查是否有有效变化：存在变化的合同且附件数量>=1
      this.checkAndSetUpdateFlag()
      
      this.editDialog.visible = false
    },
    remove() {
      const self = this
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedContractKeys.push(row.uuid)
          // 记录删除的合同
          this.changedContracts.add('deleted_' + row.uuid)
        }
        
        // 检查是否有有效变化：存在变化的合同且附件数量>=1
        this.checkAndSetUpdateFlag()
      }).catch(() => { })
    },
    uploadAttachment(uuid) {
      if (!uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotUploadFileOfNewContract'))
        return
      }
      const fileUpload = this.fileUpload
      fileUpload.businessId = uuid
      fileUpload.parameters.uuid = uuid
      fileUpload.visible = true
    },
    checkForm() {
      if (!this.editDialog.form.beginDate || !this.editDialog.form.endDate) {
        this.$message.error(this.$t('Partners.effectiveAndExpirationDateCannotBlank'))
        return false
      }
      return true
    },
    onUploadDone(data) {
      if (data) {
        updateContractFunc({ anyStr: data })
      }
      if (!this.isEdit) return
      this.toQuery()
      // 上传附件会导致附件数量变化，标记当前操作的合同为已变化
      // 由于toQuery会重新加载数据，需要在加载前记录
      this.setUpdateContractFlag('1')
    },
    // 检查并设置更新标识
    checkAndSetUpdateFlag() {
      // 遍历所有发生变化的合同
      for (const contractId of this.changedContracts) {
        // 查找对应的合同记录
        let contract = null
        if (contractId.startsWith('new_')) {
          // 新增的合同，通过seq查找
          const seq = parseInt(contractId.replace('new_', ''))
          contract = this.rowData.find(c => c.seq === seq)
        } else if (contractId.startsWith('deleted_')) {
          // 删除的合同，已经在rowData中不存在，跳过
          continue
        } else {
          // 编辑的合同，通过uuid查找
          contract = this.rowData.find(c => c.uuid === contractId)
        }
        
        // 如果找到合同记录，检查其附件数量是否>=1
        if (contract) {
          const documentSize = contract.documentSize || 0
          if (documentSize >= 1) {
            // 存在有效变化的合同，设置标识
            this.setUpdateContractFlag('1')
            return
          }
        }
      }
    },
    // 设置合同更新标识（以最后一次操作为准）
    setUpdateContractFlag(flag) {
      // 每次调用都覆盖之前的值，保持最后一次操作的标识
      this.updateContractFlag = flag
    },
    // 切换合同限制状态
    toggleContractLimit() {
      if (this.contractLimitEnabled) {
        // 禁用合同限制
        this.disableContractLimit()
      } else {
        // 启用合同限制，需要校验结算类型
        this.enableContractLimit()
      }
    },
    // 启用合同限制
    async enableContractLimit() {
      try {
        // // 获取信用账款信息
        // const creditInfo = await this.getCreditInfo()
        // if (!creditInfo) {
        //   this.$message.warning('该合作伙伴没有信用账款信息，无法启用合同限制')
        //   return
        // }
        // // 校验结算类型：creditDateLimited === 0 且 creditDateType 不是 'n' 表示票结
        // const isTicketSettlement = creditInfo.creditDateLimited === 0 && creditInfo.creditDateType !== 'n'
        // if (isTicketSettlement) {
        //   this.$message.warning(this.$t('Partners.ticketSettlementCannotEnable'))
        //   return
        // }

        // 直接调用后端接口启用合同限制（不再弹出确认框）
        const res = await apiEnableContractLimit({
          companyUuid: this.filter.companyUuid
        })
        
        // 后端返回格式: {"code":"0","data":null,"errors":null,"message":"接口调用成功。","messageId":"","ok":true}
        // 判断成功：ok=true 或 code="0"
        if (res && (res.ok === true || res.code === '0' || res.code === 0)) {
          // 重新加载合同限制状态（包含可放号天数）
          await this.loadContractLimitStatus()
          // 成功，不显示提示，按钮状态变化已有视觉反馈
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        console.error('启用合同限制失败:', error)
        this.$message.error(error.message || '操作失败')
      }
    },
    // 禁用合同限制
    async disableContractLimit() {
      try {
        const res = await apiDisableContractLimit({
          companyUuid: this.filter.companyUuid
        })
        
        // 后端返回格式: {"code":"0","data":null,"errors":null,"message":"接口调用成功。","messageId":"","ok":true}
        // 判断成功：ok=true 或 code="0"
        if (res && (res.ok === true || res.code === '0' || res.code === 0)) {
          this.contractLimitEnabled = false
          // 成功，不显示提示，按钮状态变化已有视觉反馈
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        console.error('禁用合同限制失败:', error)
        this.$message.error(error.message || '操作失败')
      }
    },
    // 获取信用账款信息
    async getCreditInfo() {
      if (this.creditInfo) {
        return this.creditInfo
      }
      // 优先从父组件获取信用账款信息（如果已经加载过）
      try {
        const parent = this.$parent
        if (parent && parent.$refs && parent.$refs.creditInfoForm) {
          const creditForm = parent.$refs.creditInfoForm
          if (creditForm && creditForm.form) {
            this.creditInfo = creditForm.form
            return this.creditInfo
          }
        }
      } catch (error) {
        console.error('从父组件获取信用账款信息失败:', error)
      }
      // 如果父组件没有，则通过API查询
      try {
        const companyUuid = this.filter.companyUuid
        if (!companyUuid) {
          return null
        }
        const res = await getCreditInfoList({ companyUuid })
        if (res.ok && res.data && res.data.list && res.data.list.length > 0) {
          this.creditInfo = res.data.list[0]
          return this.creditInfo
        }
      } catch (error) {
        console.error('通过API获取信用账款信息失败:', error)
      }
      return null
    },
    // 加载合同限制状态
    async loadContractLimitStatus() {
      try {
        const companyUuid = this.filter.companyUuid
        if (!companyUuid) {
          return
        }
        
        // 检查用户是否有权限，如果没有权限则不加载
        if (!this.$checkPermission(['button_enable_contract_limit'])) {
          console.log('用户没有合同限制权限，不加载状态')
          return
        }
        
        // 调用后端接口获取合同限制状态
        const res = await getContractLimitStatus({ companyUuid })
        
        // 后端返回 Result<ContractLimitVO>，判断成功：ok=true 或 code="0"
        if (res && (res.ok === true || res.code === '0' || res.code === 0) && res.data) {
          // 设置合同限制状态："1"-启用，"0"-禁用
          this.contractLimitEnabled = res.data.contractLimitEnabled === '1'
          
          // 设置可放号天数（确保为整数）
          this.availableReleaseDays = parseInt(res.data.availableReleaseDays) || 0
          
          // 设置可放号截止日期（截取 yyyy-MM-dd，去除时间部分）
          if (res.data.releaseDeadlineDate) {
            const dateStr = String(res.data.releaseDeadlineDate).substring(0, 10)
            this.releaseDeadlineDate = dateStr
          } else {
            this.releaseDeadlineDate = ''
          }
          
        } else {
          console.warn('获取合同限制状态失败，使用默认值')
        }
      } catch (error) {
        console.error('加载合同限制状态失败:', error)
      }
    },
    // 显示编辑放号天数弹窗
    showEditReleaseDaysDialog() {
      this.editReleaseDaysDialog.form.availableReleaseDays = this.availableReleaseDays
      // 如果已有截止日期则回显，否则根据可放号天数计算
      if (this.releaseDeadlineDate) {
        this.editReleaseDaysDialog.form.releaseDeadlineDate = this.releaseDeadlineDate
      } else {
        this.editReleaseDaysDialog.form.releaseDeadlineDate = this.calcDeadlineDate(this.availableReleaseDays)
      }
      this.editReleaseDaysDialog.visible = true
    },
    // 放号天数变化时联动更新日期
    onReleaseDaysChange(value) {
      this.editReleaseDaysDialog.form.releaseDeadlineDate = this.calcDeadlineDate(value || 0)
    },
    // 截止日期变化时联动更新天数
    onReleaseDeadlineDateChange(value) {
      if (value) {
        const deadlineDate = new Date(value + 'T00:00:00')
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        const diff = deadlineDate.getTime() - now.getTime()
        const days = Math.round(diff / (1000 * 60 * 60 * 24))
        this.editReleaseDaysDialog.form.availableReleaseDays = Math.max(0, days)
      }
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 根据可放号天数计算可放号截止日期
    calcDeadlineDate(days) {
      const date = new Date()
      date.setHours(0, 0, 0, 0)
      date.setDate(date.getDate() + (parseInt(days) || 0))
      return this.formatDate(date)
    },
    // 保存编辑放号天数
    async saveEditReleaseDays() {
      const newDays = this.editReleaseDaysDialog.form.availableReleaseDays
      const oldDays = this.availableReleaseDays
      const newDeadlineDate = this.editReleaseDaysDialog.form.releaseDeadlineDate
      const oldDeadlineDate = this.releaseDeadlineDate
      const daysChange = newDays - oldDays
      
      // // 判断数值是否发生变化（放号天数或可放号截止日期任一变化）
      // const hasChanged = newDays !== oldDays || newDeadlineDate !== oldDeadlineDate
      
      // if (hasChanged) {
        // 先调用后端接口获取历史数据
        let updateCount = 0
        let cumulativeDaysChange = 0
        
        try {
          const historyRes = await getReleaseDaysHistory({
            companyUuid: this.filter.companyUuid
          })
          
          if (historyRes && historyRes.data) {
            updateCount = historyRes.data.updateCount || 0
            cumulativeDaysChange = historyRes.data.totalAddedDays || 0
          }
        } catch (error) {
          console.error('获取历史记录失败:', error)
          // 如果获取失败，使用本地缓存的数据作为兜底
          updateCount = this.editReleaseCount
          cumulativeDaysChange = this.cumulativeDaysChange
        }
        
        // 获取信用账款信息，判断是否需要弹出改为票结客户的确认
        const creditInfo = await this.getCreditInfo()

        if (creditInfo && creditInfo.creditDateLimited > 0) {
          // 情况1：信用账款有值且 creditDateLimited > 0，弹出确认对话框
          const confirmMessage = this.$t('Partners.editReleaseDaysConfirm', [
            updateCount + 1,
            cumulativeDaysChange
          ])
          let closeOnly = false // 标记是否仅关闭小弹窗（点X号）

          try {
            await this.$confirm(confirmMessage, this.$t('common.tips.prompt'), {
              confirmButtonText: this.$t('common.btn.yes'),
              cancelButtonText: this.$t('common.btn.no'),
              closeOnClickModal: false,
              distinguishCancelAndClose: true, // 区分取消和关闭
              type: 'warning'
            })

            // 用户选择"是"：改为票结客户
            await this.saveAsTicketSettlement(newDays, daysChange)
          } catch (cancelError) {
            // 区分点击"否"（cancel）和X号/ESC（close）
            if (cancelError === 'cancel') {
              // 用户点击"否"：仅保存放号天数
              await this.saveReleaseDaysOnly(newDays, daysChange)
            } else {
              // 点击X号或ESC：仅关闭小弹窗，保留大弹窗
              closeOnly = true
            }
          }
          // 如果是点击X号关闭，不关闭大弹窗
          if (closeOnly) return
        } else {
          // 情况2：信用账款为空或 creditDateLimited 等于0，弹出提示文案并进行放号天数修改
          const infoMessage = this.$t('Partners.editReleaseDaysInfoOnly', [
            updateCount + 1,
            cumulativeDaysChange
          ])
          this.$message({
            message: infoMessage,
            type: 'warning',
            duration: 3000
          })
          // 进行放号天数数据的修改操作
          await this.saveReleaseDaysOnly(newDays, daysChange)
        }
      // } else {
      //   // 数值未变化，直接保存
      //   await this.saveReleaseDaysOnly(newDays, 0)
      // }
      
      this.editReleaseDaysDialog.visible = false
    },
    // 保存为票结客户
    async saveAsTicketSettlement(newDays, daysChange) {
      try {
        // 调用后端接口保存并改为票结
        const res = await saveReleaseDaysAndConvertToTicket({
          companyUuid: this.filter.companyUuid,
          availableReleaseDays: newDays,
          releaseDeadlineDate: this.editReleaseDaysDialog.form.releaseDeadlineDate
        })
        
        // 后端返回 Result<Void>，判断成功：ok=true 或 code="0"
        if (res && (res.ok === true || res.code === '0' || res.code === 0)) {
          // 更新本地状态
          this.availableReleaseDays = newDays
          this.releaseDeadlineDate = this.editReleaseDaysDialog.form.releaseDeadlineDate
          
          if (daysChange !== 0) {
            this.editReleaseCount += 1
            this.cumulativeDaysChange += daysChange
          }
          
          // // 禁用合同限制
          // this.contractLimitEnabled = false
          
          // 放号天数发生变化，设置 updateContractFlag='2'
          this.setUpdateContractFlag('2')
          
          // 更新父组件的信用账款信息
          await this.updateCreditInfoToTicket()
          
          // 不弹出成功提示
        } else {
          this.$message.error(res.message || this.$t('common.tips.operationFailed'))
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error.message || this.$t('common.tips.operationFailed'))
      }
    },
    // 仅保存放号天数
    async saveReleaseDaysOnly(newDays, daysChange) {
      try {
        // 调用后端接口保存
        const res = await saveReleaseDays({
          companyUuid: this.filter.companyUuid,
          availableReleaseDays: newDays,
          releaseDeadlineDate: this.editReleaseDaysDialog.form.releaseDeadlineDate
        })
        
        // 后端返回 Result<Void>，判断成功：ok=true 或 code="0"
        if (res && (res.ok === true || res.code === '0' || res.code === 0)) {
          // 更新本地状态
          this.availableReleaseDays = newDays
          this.releaseDeadlineDate = this.editReleaseDaysDialog.form.releaseDeadlineDate
          
          if (daysChange !== 0) {
            this.editReleaseCount += 1
            this.cumulativeDaysChange += daysChange
          }
          
          // 放号天数发生变化，设置 updateContractFlag='2'
          this.setUpdateContractFlag('2')
          
          // 不弹出成功提示
        } else {
          this.$message.error(res.message || this.$t('common.tips.operationFailed'))
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error.message || this.$t('common.tips.operationFailed'))
      }
    },
    // 更新信用账款信息为票结
    async updateCreditInfoToTicket() {
      try {
        // 方式1：通过事件总线广播，creditInfoForm 组件监听并自行更新（最可靠）
        this.$root.$emit('convertToTicketSettlement')
        // 方式2：同时通过 ref 直接调用作为双保险
        this.$nextTick(() => {
          const parent = this.$parent
          if (parent && parent.$refs && parent.$refs.creditInfoForm) {
            const creditForm = parent.$refs.creditInfoForm
            if (creditForm && typeof creditForm.convertToTicketSettlement === 'function') {
              creditForm.convertToTicketSettlement()
            }
          }
        })
      } catch (error) {
        console.error('更新信用账款信息失败:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.grid-view {
  &.section {
    padding: 10px 20px;
  }
}
.release-days-info {
  margin: 10px 0;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  .label {
    font-weight: bold;
    color: #606266;
  }
  .value {
    color: #409eff;
    font-size: 16px;
    font-weight: bold;
  }
}

// 按钮容器 - 使用 flex 布局，覆盖全局样式
.button-container {
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important; // 不换行
  gap: 8px; // 按钮之间的间距
  overflow-x: auto; // 超出时横向滚动
  line-height: normal !important; // 覆盖全局 line-height: 28px
  padding-left: 5px !important; // 保持与全局样式一致
}

// 内联显示的可放号天数
.release-days-inline {
  display: inline-flex !important;
  align-items: center !important;
  font-size: 14px !important; // 与按钮文字大小一致
  color: #606266;
  line-height: 32px !important; // 与按钮高度一致
  margin-left: 0;
  vertical-align: middle;
  
  .release-days-number {
    color: #f39c12; // 黄色字体
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
    padding: 2px 6px;
    border-radius: 3px;
    background-color: rgba(243, 156, 18, 0.1); // 淡黄色背景
    min-width: 20px;
    text-align: center;
  }
}

</style>

<style lang="scss">
// Popover 全局样式（必须不带scoped，因为popover内容挂载到body下）
.release-days-popover {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  
  .el-popover__title {
    display: none;
  }
  
  .popover-content {
    padding: 12px 15px;
    background-color: #fff;
    border: 1px solid #f56c6c; // 整块红色边框（格子线）
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #f56c6c !important; // 红色字体
    line-height: 1.8;
    white-space: normal; // 允许换行
    
    br {
      display: block;
      content: "";
      margin: 2px 0;
    }
  }
}
</style>
